import React from 'react'

import {
  ArrowRightIcon,
  CircleCheckmarkFullIcon,
  IconSizes
} from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FullTourStep.module.scss'
import { TourRule, TourStepItem } from './FullTourStep.types'

export const FullTourStep = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_one'
  })
  const stepItems = t('items', {
    returnObjects: true
  }) as TourStepItem[]
  const rules = t('panel.rules', {
    returnObjects: true
  }) as TourRule[]

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-title'
      aria-describedby='full-tour-step-description'
    >
      <div className={styles.tourCardContent}>
        <div className={styles.tourMain}>
          <div className={styles.tourLeft}>
            <div className={styles.tourHeading}>
              <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
              <h1 id='full-tour-step-title' className={styles.tourTitle}>
                <span>{t('title_before')}</span>
                <span className={styles.titleHighlight}>
                  {t('title_highlighted')}
                </span>
              </h1>
            </div>

            <div className={styles.tourDetails}>
              <nav className={styles.path} aria-label={t('path_label')}>
                <span className={styles.pathChip}>{t('path_from')}</span>
                <ArrowRightIcon
                  aria-hidden='true'
                  color='var(--white)'
                  size={IconSizes.Size16}
                />
                <span className={styles.pathChip}>{t('path_to')}</span>
              </nav>

              <p
                id='full-tour-step-description'
                className={styles.tourDescription}
              >
                {t('description')}
              </p>

              <ul className={styles.tourItems}>
                {stepItems.map(item => (
                  <li key={item.label} className={styles.tourItem}>
                    <CircleCheckmarkFullIcon
                      aria-hidden='true'
                      color='#BAE281'
                      size={IconSizes.Size18}
                    />
                    <span>
                      <strong>{item.label}</strong> — {item.description}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className={styles.tourPanel}>
            <div className={styles.panelIntro}>
              <h2>{t('panel.title')}</h2>
              <p>{t('panel.description')}</p>
            </div>

            <div className={styles.rules}>
              {rules.map(rule => (
                <div key={rule.label} className={styles.rule}>
                  <strong>{rule.label}</strong>
                  <span>{rule.value}</span>
                </div>
              ))}
            </div>

            <p className={styles.warning}>{t('panel.warning')}</p>
          </div>
        </div>
      </div>
    </section>
  )
}
